(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hc-featured-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setSlide(root, n) {
      var slides = root.querySelectorAll('.hc-fg__slide');
      slides.forEach(function (s) {
        s.classList.toggle('is-active', Number(s.dataset.slide) === n);
      });
      root.querySelectorAll('[data-hotspot]').forEach(function (h) {
        var on = Number(h.dataset.onSlide || 0);
        var show = on === 0 || on === n;
        h.hidden = !show;
      });
    }

    function init(root) {
      if (root.dataset.hcFgReady) return;
      root.dataset.hcFgReady = '1';
      var slides = root.querySelectorAll('.hc-fg__slide');
      setSlide(root, 1);
      if (slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var current = 1;
      var speed = Number(root.dataset.speed) || 5000;
      root._hcFgTimer = setInterval(function () {
        if (root.matches(':hover')) return;
        current = current >= slides.length ? 1 : current + 1;
        setSlide(root, current);
      }, speed);
    }

    function initAll() {
      document.querySelectorAll('[data-hc-fg]').forEach(function (root) {
        init(root);
        collapse(root);
        fillGallery(root);
      });
    }

    function collapse(root) {
      var limit = Number(root.dataset.more) || 0;
      var wrap = root.querySelector('[data-hc-fg-more-wrap]');
      if (!limit || !wrap || root.dataset.hcFgOpen) return;
      var items = root.querySelectorAll('.hc-fg__item');
      items.forEach(function (li, i) { li.hidden = i >= limit; });
      wrap.hidden = items.length <= limit;
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hc-fg-more]');
      if (!btn) return;
      var root = btn.closest('[data-hc-fg]');
      root.dataset.hcFgOpen = '1';
      root.querySelectorAll('.hc-fg__item[hidden]').forEach(function (li) { li.hidden = false; });
      btn.closest('[data-hc-fg-more-wrap]').hidden = true;
    });

    /* Shopify Liquid only sees the first 250 variants of a product, so circles for later
       variants (most DTO colourways) are filled in here from the Storefront API. */
    function normKey(t) {
      return String(t || '').toLowerCase()
        .replace(/œ/g, 'oe').replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/ß/g, 'ss')
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^\p{L}\p{N}]+/gu, ' ')
        .split(/\s+/).filter(Boolean).join(' ');
    }

    function itemInfo(v, root) {
      var opts = v.selectedOptions || [];
      var cw = '', base = '';
      opts.forEach(function (o) {
        if (/colou?r/i.test(o.name)) cw = o.value;
        if (/base/i.test(o.name)) base = shortBase(o.value);
      });
      if (!cw && opts[0]) cw = opts[0].value;
      if (!base && opts[1]) base = shortBase(opts[1].value);
      var dyedOn = root.dataset.dyedOn || 'dyed on';
      var label = (cw && base) ? cw + ' ' + dyedOn + ' ' + base : v.product.title + (v.title && v.title !== 'Default Title' ? ', ' + v.title : '');
      return {
        cw: cw, base: base, dyedOn: dyedOn, label: label,
        keys: [normKey(v.title), normKey(label), normKey(v.product.title + ' ' + v.title), normKey(cw)]
      };
    }

    function exactCard(keys, cards) {
      for (var i = 0; i < cards.length; i++) {
        if (keys.indexOf(normKey(cards[i].key)) > -1) return cards[i];
      }
      return null;
    }

    function prefixCard(keys, cards, usedExact) {
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        if (usedExact[c.id]) continue;
        var pre = normKey(c.key);
        if (!pre) continue;
        pre += ' ';
        if ((keys[1] + ' ').indexOf(pre) === 0 || (keys[3] + ' ').indexOf(pre) === 0) return c;
      }
      return null;
    }

    function shortBase(t) {
      return String(t || '').replace(/^\([^)]*\)\s*/, '').replace(/\s*-\s*\d+\s*m\s*$/i, '').trim();
    }

    function readJSON(el) {
      if (!el) return null;
      var t = el.textContent.trim();
      try { return JSON.parse(t); } catch (e) {}
      try {
        var ta = document.createElement('textarea');
        ta.innerHTML = t;
        return JSON.parse(ta.value);
      } catch (e2) { return null; }
    }

    function money(p) {
      if (!p) return '';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: p.currencyCode }).format(Number(p.amount));
      } catch (e) { return p.amount + ' ' + p.currencyCode; }
    }

    function sized(url, w) {
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }

    function buildItem(v, root, cards, usedExact) {
      var info = itemInfo(v, root);
      var cw = info.cw, base = info.base, dyedOn = info.dyedOn, label = info.label;
      var card = exactCard(info.keys, cards) || prefixCard(info.keys, cards, usedExact);

      var li = el('li', 'hc-fg__item');
      li.dataset.vid = v.id.split('/').pop();
      var a = el('a', 'hc-fg__link');
      a.href = '/products/' + v.product.handle + '?variant=' + li.dataset.vid;
      a.setAttribute('aria-label', label);
      var circle = el('span', 'hc-fg__circle');
      if (v.image && v.image.url) {
        var img = el('img', 'hc-fg__img hc-fg__img--main');
        img.src = sized(v.image.url, 600);
        img.srcset = [200, 300, 400, 600].map(function (w) { return sized(v.image.url, w) + ' ' + w + 'w'; }).join(', ');
        img.sizes = '(min-width: 769px) 20vw, 45vw';
        img.loading = 'lazy';
        img.alt = label;
        circle.appendChild(img);
      }
      if (card) {
        if (card.hover) {
          a.classList.add('hc-fg__link--swap');
          var hi = el('img', 'hc-fg__img hc-fg__img--hover');
          hi.src = card.hover;
          hi.loading = 'lazy';
          hi.alt = '';
          circle.appendChild(hi);
        }
        if (card.note || card.price) a.setAttribute('data-tip', '');
        if (card.note) a.dataset.note = card.note;
        if (card.price) a.dataset.price = money(v.price);
        var warn = root.querySelector('.hc-fg__editor-warn[data-card-id="' + card.id + '"]');
        if (warn) warn.remove();
      }
      a.appendChild(circle);
      var cap = el('span', 'hc-fg__caption');
      if (cw && base) {
        cap.appendChild(el('span', 'hc-fg__cw', cw));
        cap.appendChild(document.createTextNode(' '));
        cap.appendChild(el('span', 'hc-fg__join', dyedOn));
        cap.appendChild(document.createTextNode(' '));
        cap.appendChild(el('span', 'hc-fg__base', base));
      } else {
        cap.appendChild(el('span', 'hc-fg__cw', label));
      }
      a.appendChild(cap);
      li.appendChild(a);
      return li;
    }

    function fillGallery(root) {
      if (root.dataset.hcFgFilled) return;
      root.dataset.hcFgFilled = '1';
      var ids = readJSON(root.querySelector('[data-hc-fg-ids]'));
      if (!Array.isArray(ids) || !ids.length) return;
      ids = ids.slice(0, Number(root.dataset.max) || ids.length);
      var grid = root.querySelector('.hc-fg__grid');
      var existing = {};
      if (grid) grid.querySelectorAll('[data-vid]').forEach(function (li) { existing[li.dataset.vid] = li; });
      var missing = ids.filter(function (g) { return !existing[String(g).split('/').pop()]; });
      if (!missing.length) return;
      var cards = readJSON(root.querySelector('[data-hc-fg-cards]')) || [];
      var query = '{ nodes(ids: ' + JSON.stringify(missing) + ') { ... on ProductVariant { id title price { amount currencyCode } image { url } selectedOptions { name value } product { handle title } } } }';
      fetch('/api/2025-07/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ query: query })
      }).then(function (r) { return r.json(); }).then(function (d) {
        var found = {};
        ((d && d.data && d.data.nodes) || []).forEach(function (v) { if (v && v.id) found[v.id] = v; });
        if (!grid) {
          grid = el('ul', 'hc-fg__grid');
          grid.setAttribute('role', 'list');
          var msg = root.querySelector('.hc-fg__editor-msg');
          if (msg) msg.replaceWith(grid);
          else root.querySelector('.hc-fg__panel').appendChild(grid);
        }
        /* Cards that match some circle exactly are not used for start of name matches */
        var usedExact = {};
        cards.forEach(function (c) { if (c.exact) usedExact[c.id] = true; });
        Object.keys(found).forEach(function (g) {
          var c = exactCard(itemInfo(found[g], root).keys, cards);
          if (c) usedExact[c.id] = true;
        });
        var frag = document.createDocumentFragment();
        ids.forEach(function (g) {
          var vid = String(g).split('/').pop();
          if (existing[vid]) frag.appendChild(existing[vid]);
          else if (found[g]) frag.appendChild(buildItem(found[g], root, cards, usedExact));
        });
        grid.innerHTML = '';
        grid.appendChild(frag);
        collapse(root);
      }).catch(function () {});
    }

    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    function moveTip(tip, e) {
      var gap = 18;
      var x = e.clientX + gap;
      var y = e.clientY + gap;
      var w = tip.offsetWidth;
      var h = tip.offsetHeight;
      if (x + w > window.innerWidth - 8) x = e.clientX - w - gap;
      if (y + h > window.innerHeight - 8) y = e.clientY - h - gap;
      tip.style.left = x + 'px';
      tip.style.top = y + 'px';
    }

    document.addEventListener('mousemove', function (e) {
      if (!canHover.matches) return;
      var link = e.target.closest('.hc-fg [data-tip]');
      document.querySelectorAll('[data-hc-fg-tip]').forEach(function (t) {
        if (!link || !t.closest('[data-hc-fg]').contains(link)) t.hidden = true;
      });
      if (!link) return;
      var tip = link.closest('[data-hc-fg]').querySelector('[data-hc-fg-tip]');
      if (!tip) return;
      if (tip._link !== link) {
        tip._link = link;
        var n = tip.querySelector('[data-tip-note]');
        var p = tip.querySelector('[data-tip-price]');
        n.textContent = link.dataset.note || '';
        n.hidden = !link.dataset.note;
        p.textContent = link.dataset.price || '';
        p.hidden = !link.dataset.price;
      }
      tip.hidden = false;
      moveTip(tip, e);
    });

    document.addEventListener('mouseleave', function () {
      document.querySelectorAll('[data-hc-fg-tip]').forEach(function (t) { t.hidden = true; });
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('[data-hc-fg]');
      if (root && root._hcFgTimer) clearInterval(root._hcFgTimer);
    });

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest('.hc-fg__slide');
      if (slide) setSlide(slide.closest('[data-hc-fg]'), Number(slide.dataset.slide));
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-palette-dock"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* H&C palette store, shared by the palette button, the floating tab and the palette page.
       Saved in this browser only (localStorage). Each item: id (variant), h (product handle), q (skeins), t (thumbnail). */
    window.HCPalette = window.HCPalette || (function () {
      var KEY = 'hcPalette';
      var mem = [];
      function read() {
        try {
          var a = JSON.parse(localStorage.getItem(KEY) || '[]');
          if (Array.isArray(a)) return a;
        } catch (e) {}
        return mem.slice();
      }
      function fire() {
        document.dispatchEvent(new CustomEvent('hc:palette'));
      }
      function write(a) {
        mem = a.slice();
        try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
        fire();
      }
      function idx(a, id) {
        id = String(id);
        for (var i = 0; i < a.length; i++) if (String(a[i].id) === id) return i;
        return -1;
      }
      window.addEventListener('storage', function (e) { if (e.key === KEY) fire(); });
      return {
        list: read,
        count: function () {
          return read().reduce(function (n, x) { return n + (Number(x.q) || 0); }, 0);
        },
        get: function (id) {
          var a = read();
          var i = idx(a, id);
          return i > -1 ? a[i] : null;
        },
        add: function (item) {
          var a = read();
          var i = idx(a, item.id);
          if (i > -1) {
            for (var k in item) if (item[k] !== undefined && item[k] !== '') a[i][k] = item[k];
          } else {
            a.push(item);
          }
          write(a);
        },
        remove: function (id) {
          var a = read();
          var i = idx(a, id);
          if (i > -1) { a.splice(i, 1); write(a); }
        },
        setQty: function (id, q) {
          var a = read();
          var i = idx(a, id);
          if (i > -1) { a[i].q = Math.max(1, Number(q) || 1); write(a); }
        },
        merge: function (items) {
          var a = read();
          items.forEach(function (it) {
            var i = idx(a, it.id);
            if (i > -1) a[i].q = it.q; else a.push(it);
          });
          write(a);
        },
        clear: function () { write([]); },
        root: function () {
          var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          return r.charAt(r.length - 1) === '/' ? r : r + '/';
        }
      };
    })();

    function refresh() {
      var list = window.HCPalette.list();
      document.querySelectorAll('[data-hc-pal-dock]').forEach(function (dock) {
        dock.hidden = list.length === 0 && dock.dataset.showEmpty !== 'true';
        var count = dock.querySelector('[data-hc-pal-count]');
        if (count) count.textContent = list.length;
        var dots = dock.querySelector('[data-hc-pal-dots]');
        if (!dots) return;
        dots.innerHTML = '';
        list.slice(-5).forEach(function (item) {
          var d = document.createElement('span');
          d.className = 'hc-pal-dock__dot';
          if (item.t) d.style.backgroundImage = 'url("' + item.t + '")';
          dots.appendChild(d);
        });
      });
    }
    document.addEventListener('hc:palette', refresh);
    document.addEventListener('shopify:section:load', refresh);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refresh);
    } else {
      refresh();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-palette"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* H&C palette store, shared by the palette button, the floating tab and the palette page.
       Saved in this browser only (localStorage). Each item: id (variant), h (product handle), q (skeins), t (thumbnail). */
    window.HCPalette = window.HCPalette || (function () {
      var KEY = 'hcPalette';
      var mem = [];
      function read() {
        try {
          var a = JSON.parse(localStorage.getItem(KEY) || '[]');
          if (Array.isArray(a)) return a;
        } catch (e) {}
        return mem.slice();
      }
      function fire() {
        document.dispatchEvent(new CustomEvent('hc:palette'));
      }
      function write(a) {
        mem = a.slice();
        try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
        fire();
      }
      function idx(a, id) {
        id = String(id);
        for (var i = 0; i < a.length; i++) if (String(a[i].id) === id) return i;
        return -1;
      }
      window.addEventListener('storage', function (e) { if (e.key === KEY) fire(); });
      return {
        list: read,
        count: function () {
          return read().reduce(function (n, x) { return n + (Number(x.q) || 0); }, 0);
        },
        get: function (id) {
          var a = read();
          var i = idx(a, id);
          return i > -1 ? a[i] : null;
        },
        add: function (item) {
          var a = read();
          var i = idx(a, item.id);
          if (i > -1) {
            for (var k in item) if (item[k] !== undefined && item[k] !== '') a[i][k] = item[k];
          } else {
            a.push(item);
          }
          write(a);
        },
        remove: function (id) {
          var a = read();
          var i = idx(a, id);
          if (i > -1) { a.splice(i, 1); write(a); }
        },
        setQty: function (id, q) {
          var a = read();
          var i = idx(a, id);
          if (i > -1) { a[i].q = Math.max(1, Number(q) || 1); write(a); }
        },
        merge: function (items) {
          var a = read();
          items.forEach(function (it) {
            var i = idx(a, it.id);
            if (i > -1) a[i].q = it.q; else a.push(it);
          });
          write(a);
        },
        clear: function () { write([]); },
        root: function () {
          var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          return r.charAt(r.length - 1) === '/' ? r : r + '/';
        }
      };
    })();

    var SIZE_KEY = 'hcPaletteSize';

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }

    function readJSON(node) {
      if (!node) return {};
      try { return JSON.parse(node.textContent); } catch (e) { return {}; }
    }

    /* Shared palettes travel in the link as handle.variant.quantity joined by ~ */
    function encode(list) {
      return list.map(function (x) { return x.h + '.' + x.id + '.' + x.q; }).join('~');
    }

    function decode(str) {
      return String(str || '').split('~').map(function (part) {
        var bits = part.split('.');
        if (bits.length < 3) return null;
        return { h: bits[0], id: bits[1], q: Math.max(1, parseInt(bits[2], 10) || 1), t: '' };
      }).filter(function (x) { return x && x.h && /^\d+$/.test(x.id); });
    }

    var cache = {};

    function fetchCard(item) {
      if (cache[item.id]) return Promise.resolve(cache[item.id]);
      var url = window.HCPalette.root() + 'products/' + encodeURIComponent(item.h) + '?variant=' + item.id + '&section_id=hc-palette';
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var c = doc.querySelector('[data-hc-pal-card]');
          if (!c || String(c.dataset.id) !== String(item.id)) return null;
          var d = c.dataset;
          cache[item.id] = {
            id: d.id, h: d.handle, url: d.url, price: Number(d.price) || 0, priceF: d.priceF,
            status: d.status, max: d.max === '' ? null : Number(d.max), proto: d.proto === 'true',
            cw: d.cw, base: d.base, photo: d.photo, thumb: d.thumb
          };
          return cache[item.id];
        })
        .catch(function () { return null; });
    }

    function init(root) {
      if (root.dataset.hcPalReady) return;
      root.dataset.hcPalReady = '1';

      var L = readJSON(root.querySelector('[data-hc-pal-labels]'));
      var grid = root.querySelector('[data-hc-pal-grid]');
      var empty = root.querySelector('[data-hc-pal-empty]');
      var bar = root.querySelector('[data-hc-pal-bar]');
      var foot = root.querySelector('[data-hc-pal-foot]');
      var msg = root.querySelector('[data-hc-pal-msg]');
      var sharedBox = root.querySelector('[data-hc-pal-shared]');
      var cartBtn = root.querySelector('[data-hc-pal-cart]');
      var clearBtn = root.querySelector('[data-hc-pal-clear]');
      var currency = root.dataset.currency || 'EUR';
      var lang = document.documentElement.lang || 'en';

      var params = new URLSearchParams(location.search);
      var shared = params.get('p') ? decode(params.get('p')) : null;
      if (shared && !shared.length) shared = null;
      if (sharedBox) sharedBox.hidden = !shared;

      function items() { return shared || window.HCPalette.list(); }

      function setQty(id, q) {
        if (shared) {
          shared.forEach(function (x) { if (String(x.id) === String(id)) x.q = Math.max(1, q); });
          totals();
        } else {
          window.HCPalette.setQty(id, q);
        }
      }

      function removeItem(id) {
        if (shared) {
          shared = shared.filter(function (x) { return String(x.id) !== String(id); });
          render();
        } else {
          window.HCPalette.remove(id);
        }
      }

      function money(cents) {
        try {
          return new Intl.NumberFormat(lang, { style: 'currency', currency: currency }).format(cents / 100);
        } catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
      }

      function canBuy(info) {
        return info && (info.status === 'stock' || info.status === 'dto' || info.status === 'dto-low');
      }

      function statusText(info) {
        if (info.proto && info.status === 'stock') return (L.proto || '') + (info.max != null ? ' · ' + (L.stock || '').replace('[n]', info.max) : '');
        switch (info.status) {
          case 'dto': return L.dto;
          case 'dto-low': return L.dtoLow;
          case 'dto-out': return L.dtoOut;
          case 'paused': return L.paused;
          case 'out': return L.out;
          default: return info.max != null ? (L.stock || '').replace('[n]', info.max) : '';
        }
      }

      function totals() {
        var skeins = 0, cents = 0;
        items().forEach(function (x) {
          var info = cache[x.id];
          if (!canBuy(info)) return;
          var q = Number(x.q) || 1;
          if (info.max != null) q = Math.min(q, info.max);
          skeins += q;
          cents += q * info.price;
        });
        root.querySelector('[data-hc-pal-skeins]').textContent = skeins;
        root.querySelector('[data-hc-pal-total]').textContent = money(cents);
      }

      function buildCard(x, info) {
        var li = el('li', 'hc-pal__item');
        li.dataset.id = x.id;
        if (!info) {
          li.appendChild(el('span', 'hc-pal__tag hc-pal__tag--off', L.gone));
          var gone = el('button', 'hc-pal__remove', L.remove);
          gone.type = 'button';
          gone.addEventListener('click', function () { removeItem(x.id); });
          li.appendChild(gone);
          return li;
        }
        if (!canBuy(info)) li.classList.add('is-off');
        var href = window.HCPalette.root() + info.url.replace(/^\//, '');
        var photo = el('a', 'hc-pal__photo');
        photo.href = href;
        if (info.photo) {
          var img = el('img');
          img.src = info.photo;
          img.alt = info.cw + ' ' + (L.join || '') + ' ' + info.base;
          img.loading = 'lazy';
          photo.appendChild(img);
        }
        li.appendChild(photo);

        var name = el('a', 'hc-pal__name');
        name.href = href;
        name.appendChild(el('span', 'hc-pal__cw', info.cw));
        name.appendChild(document.createTextNode(' ' + (L.join || '') + ' '));
        name.appendChild(el('span', 'hc-pal__base', info.base));
        li.appendChild(name);

        var st = statusText(info);
        if (st) {
          var tagCls = 'hc-pal__tag';
          if (info.status === 'dto-low') tagCls += ' hc-pal__tag--warn';
          if (!canBuy(info)) tagCls += ' hc-pal__tag--off';
          li.appendChild(el('span', tagCls, st));
        }
        li.appendChild(el('span', 'hc-pal__price', info.priceF));

        if (canBuy(info)) {
          var qty = el('div', 'hc-pal__qty');
          var minus = el('button', '', '−');
          minus.type = 'button';
          minus.setAttribute('aria-label', '−1');
          var input = el('input');
          input.type = 'number';
          input.min = '1';
          if (info.max != null) input.max = String(info.max);
          input.value = info.max != null ? Math.min(x.q, info.max) : x.q;
          input.setAttribute('aria-label', L.qty || 'Quantity');
          var plus = el('button', '', '+');
          plus.type = 'button';
          plus.setAttribute('aria-label', '+1');
          function commit(v) {
            v = Math.max(1, parseInt(v, 10) || 1);
            if (info.max != null) v = Math.min(v, info.max);
            input.value = v;
            setQty(x.id, v);
          }
          minus.addEventListener('click', function () { commit(Number(input.value) - 1); });
          plus.addEventListener('click', function () { commit(Number(input.value) + 1); });
          input.addEventListener('change', function () { commit(input.value); });
          qty.appendChild(minus);
          qty.appendChild(input);
          qty.appendChild(plus);
          li.appendChild(qty);
        }

        var rm = el('button', 'hc-pal__remove', L.remove);
        rm.type = 'button';
        rm.addEventListener('click', function () { removeItem(x.id); });
        li.appendChild(rm);
        return li;
      }

      var renderRun = 0;
      function render() {
        var run = ++renderRun;
        var list = items();
        empty.hidden = list.length > 0;
        bar.hidden = list.length === 0;
        foot.hidden = list.length === 0;
        if (!list.length) { grid.innerHTML = ''; return; }
        Promise.all(list.map(fetchCard)).then(function (infos) {
          if (run !== renderRun) return;
          var frag = document.createDocumentFragment();
          list.forEach(function (x, i) {
            var info = infos[i];
            if (info && !x.t && info.thumb && !shared) {
              x.t = info.thumb;
              window.HCPalette.add({ id: x.id, t: info.thumb });
              return;
            }
            frag.appendChild(buildCard(x, info));
          });
          if (run !== renderRun) return;
          grid.innerHTML = '';
          grid.appendChild(frag);
          totals();
        });
      }

      /* Photo size */
      function setSize(sz) {
        grid.classList.remove('hc-pal__grid--s', 'hc-pal__grid--m', 'hc-pal__grid--l');
        grid.classList.add('hc-pal__grid--' + sz);
        root.querySelectorAll('[data-hc-pal-size]').forEach(function (b) {
          b.setAttribute('aria-pressed', b.dataset.hcPalSize === sz ? 'true' : 'false');
        });
        try { localStorage.setItem(SIZE_KEY, sz); } catch (e) {}
      }
      var savedSize = 'm';
      try { savedSize = localStorage.getItem(SIZE_KEY) || 'm'; } catch (e) {}
      setSize(savedSize);
      root.querySelectorAll('[data-hc-pal-size]').forEach(function (b) {
        b.addEventListener('click', function () { setSize(b.dataset.hcPalSize); });
      });

      /* Share link */
      root.querySelector('[data-hc-pal-share]').addEventListener('click', function () {
        var link = location.origin + location.pathname + '?p=' + encodeURIComponent(encode(items()));
        function done() { msg.textContent = L.copied; }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(link).then(done, function () { window.prompt('', link); });
        } else {
          window.prompt('', link);
        }
      });

      /* Clear: click twice */
      var clearArmed = false;
      clearBtn.addEventListener('click', function () {
        if (!clearArmed) {
          clearArmed = true;
          clearBtn.textContent = L.clearAgain;
          setTimeout(function () { clearArmed = false; clearBtn.textContent = clearBtn.dataset.label; }, 4000);
          return;
        }
        clearArmed = false;
        clearBtn.textContent = clearBtn.dataset.label;
        if (shared) { shared = []; render(); } else { window.HCPalette.clear(); }
      });

      /* Save a shared palette into this browser's palette */
      var saveShared = root.querySelector('[data-hc-pal-save-shared]');
      if (saveShared) saveShared.addEventListener('click', function () {
        if (!shared) return;
        var toSave = shared.map(function (x) {
          return { id: x.id, h: x.h, q: x.q, t: (cache[x.id] && cache[x.id].thumb) || '' };
        });
        shared = null;
        sharedBox.hidden = true;
        history.replaceState(null, '', location.pathname);
        window.HCPalette.merge(toSave);
      });

      /* Add everything that can be bought to the cart */
      cartBtn.addEventListener('click', function () {
        var add = [], skipped = [];
        items().forEach(function (x) {
          var info = cache[x.id];
          if (!canBuy(info)) {
            if (info) skipped.push(info.cw + ' ' + (L.join || '') + ' ' + info.base);
            return;
          }
          var q = Number(x.q) || 1;
          if (info.max != null) q = Math.min(q, info.max);
          if (q > 0) add.push({ id: Number(x.id), quantity: q });
        });
        if (!add.length) { msg.textContent = (L.skipped || '').replace('[list]', skipped.join(', ')); return; }
        cartBtn.disabled = true;
        fetch(window.HCPalette.root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: add })
        }).then(function (r) {
          return r.json().then(function (d) { return { ok: r.ok, d: d }; });
        }).then(function (res) {
          cartBtn.disabled = false;
          if (!res.ok) {
            msg.textContent = (res.d && (res.d.description || res.d.message)) || L.error;
            return;
          }
          var text = L.added || '';
          if (skipped.length) text += ' ' + (L.skipped || '').replace('[list]', skipped.join(', '));
          msg.textContent = text;
          document.dispatchEvent(new CustomEvent('cart:build'));
          setTimeout(function () { location.href = root.dataset.cartUrl || '/cart'; }, skipped.length ? 2500 : 600);
        }).catch(function () {
          cartBtn.disabled = false;
          msg.textContent = L.error;
        });
      });

      document.addEventListener('hc:palette', function () { if (!shared) render(); });
      render();
    }

    function start() {
      document.querySelectorAll('[data-hc-pal]').forEach(init);
    }
    document.addEventListener('shopify:section:load', start);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-template-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function seen(key) {
      try {
        var until = Number(localStorage.getItem(key) || 0);
        return until > Date.now();
      } catch (e) { return false; }
    }

    function remember(key, days) {
      try { localStorage.setItem(key, String(Date.now() + days * 86400000)); } catch (e) {}
    }

    function open(pop) {
      pop.hidden = false;
      var close = pop.querySelector('.hc-tpop__close');
      if (close) close.focus();
    }

    function close(pop, long) {
      pop.hidden = true;
      if (pop.dataset.design === 'true') return;
      if (pop.dataset.everyVisit === 'true' && !long) return;
      remember(pop.dataset.key, long ? 200 : Number(pop.dataset.days) || 30);
    }

    function init(pop) {
      if (pop.dataset.hcReady) return;
      pop.dataset.hcReady = '1';

      pop.addEventListener('click', function (e) {
        if (e.target.closest('[data-hc-tpop-close]')) close(pop, false);
        if (e.target.closest('[data-hc-tpop-cta]')) close(pop, true);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !pop.hidden) close(pop, false);
      });

      /* After a sign up the page reloads: show the result, and don't show the popup again for a long time */
      var form = pop.querySelector('[data-hc-tpop-form]');
      if (form && (form.querySelector('.note--success') || form.querySelector('.errors'))) {
        open(pop);
        if (form.querySelector('.note--success')) remember(pop.dataset.key, 200);
        return;
      }

      if (pop.dataset.design === 'true') return;
      if (pop.dataset.everyVisit !== 'true' && seen(pop.dataset.key)) return;
      if (pop.dataset.everyVisit === 'true') {
        try { if (sessionStorage.getItem(pop.dataset.key)) return; sessionStorage.setItem(pop.dataset.key, '1'); } catch (e) {}
      }
      setTimeout(function () { open(pop); }, (Number(pop.dataset.delay) || 0) * 1000);
    }

    function start() {
      document.querySelectorAll('[data-hc-tpop]').forEach(init);
    }

    /* Theme editor: open while the section is selected, close when it isn't */
    document.addEventListener('shopify:section:load', start);
    document.addEventListener('shopify:section:select', function (e) {
      var pop = document.querySelector('#shopify-section-' + e.detail.sectionId + ' [data-hc-tpop]');
      if (pop) open(pop);
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var pop = document.querySelector('#shopify-section-' + e.detail.sectionId + ' [data-hc-tpop]');
      if (pop) pop.hidden = true;
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-tier-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORE = 'hcTierPop:';

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function names(pop) {
      return (pop.dataset.match || '')
        .split(',')
        .map(function (n) { return n.trim().toLowerCase(); })
        .filter(Boolean);
    }

    /* The highest Sweater Weather percentage on any cart line, 0 if none */
    function tierOf(cart, list) {
      var best = 0;
      (cart.items || []).forEach(function (item) {
        (item.line_level_discount_allocations || []).forEach(function (a) {
          var title = (a.discount_application && a.discount_application.title) || '';
          var lower = title.toLowerCase();
          if (list.length && !list.some(function (n) { return lower.indexOf(n) > -1; })) return;
          var m = title.match(/(\d+(?:[.,]\d+)?)\s*%/);
          if (m) {
            var p = parseFloat(m[1].replace(',', '.'));
            if (p > best) best = p;
          }
        });
      });
      return best;
    }

    /* The block for that percentage, or the nearest one below it */
    function panelFor(pop, percent) {
      var pick = null;
      var pickPercent = -1;
      pop.querySelectorAll('[data-hc-tierpop-panel]').forEach(function (panel) {
        var p = parseFloat(panel.dataset.percent) || 0;
        if (p <= percent && p > pickPercent) {
          pick = panel;
          pickPercent = p;
        }
      });
      return pick;
    }

    function shown(key) {
      try { return parseFloat(localStorage.getItem(key)) || 0; } catch (e) { return 0; }
    }

    function remember(key, percent) {
      try { localStorage.setItem(key, String(percent)); } catch (e) {}
    }

    function burst(pop) {
      if (pop.dataset.burstOn !== 'true') return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var box = pop.querySelector('[data-hc-tierpop-burst]');
      var emojis = (pop.dataset.burst || '').split(/\s+/).filter(Boolean);
      if (!box || !emojis.length) return;
      box.innerHTML = '';
      var count = 28;
      for (var i = 0; i < count; i++) {
        var bit = document.createElement('span');
        var angle = (Math.PI * 2 * i) / count + Math.random() * 0.4;
        var reach = 140 + Math.random() * Math.min(260, window.innerWidth * 0.35);
        bit.className = 'hc-tierpop__bit';
        bit.textContent = emojis[i % emojis.length];
        bit.style.setProperty('--x', Math.round(Math.cos(angle) * reach) + 'px');
        bit.style.setProperty('--y', Math.round(Math.sin(angle) * reach) + 'px');
        bit.style.setProperty('--turn', Math.round(Math.random() * 120 - 60) + 'deg');
        bit.style.setProperty('--size', Math.round(22 + Math.random() * 22) + 'px');
        bit.style.setProperty('--delay', (Math.random() * 0.15).toFixed(2) + 's');
        box.appendChild(bit);
      }
      setTimeout(function () { box.innerHTML = ''; }, 1800);
    }

    /* quiet = no burst, no pop in, no focus (used in the theme editor while settings are being typed) */
    function open(pop, panel, quiet) {
      pop.querySelectorAll('[data-hc-tierpop-panel]').forEach(function (p) { p.hidden = p !== panel; });
      var title = panel.querySelector('.hc-tierpop__title');
      if (title) pop.setAttribute('aria-labelledby', title.id);
      pop.classList.toggle('hc-tierpop--still', !!quiet);
      pop.hidden = false;
      if (quiet) return;
      burst(pop);
      if (pop.dataset.design === 'true') return;
      pop._hcReturn = document.activeElement;
      var focus = panel.querySelector('.hc-tierpop__btn') || panel.querySelector('.hc-tierpop__close');
      if (focus) focus.focus({ preventScroll: true });
    }

    function close(pop) {
      if (pop.hidden) return;
      pop.hidden = true;
      if (pop._hcReturn && pop._hcReturn.focus) {
        try { pop._hcReturn.focus({ preventScroll: true }); } catch (e) {}
      }
    }

    function check(pop) {
      if (pop.dataset.design === 'true' || !pop.hidden) return;
      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var percent = tierOf(cart, names(pop));
          if (!percent) return;
          var key = STORE + (cart.token || 'session');
          if (percent <= shown(key)) return;
          var panel = panelFor(pop, percent);
          if (!panel) return;
          remember(key, percent);
          open(pop, panel);
        })
        .catch(function () {});
    }

    function init(pop) {
      if (pop.dataset.hcReady) return;
      pop.dataset.hcReady = '1';

      pop.addEventListener('click', function (e) {
        if (e.target.closest('[data-hc-tierpop-close]')) close(pop);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close(pop);
      });

      /* Check after anything changes the cart: adding, the drawer quantity buttons, Add all from the palette */
      var timer;
      function soon() {
        clearTimeout(timer);
        timer = setTimeout(function () { check(pop); }, 500);
      }
      document.addEventListener('ajaxProduct:added', soon);
      document.addEventListener('cart:updated', soon);
      document.addEventListener('cart:build', soon);

      /* And once when the page opens, for the cart page and anything that reloads */
      setTimeout(function () { check(pop); }, 800);
    }

    function start() {
      document.querySelectorAll('[data-hc-tierpop]').forEach(init);
    }

    /* Theme editor: show the popup while it, or one of its tier blocks, is selected.
       Typing in a setting makes the editor redraw the section: the tier on show comes straight back,
       quietly, so the cursor stays in the setting and the burst only plays when you pick a different tier. */
    var editor = { blockId: null };
    function inSection(id) {
      return document.querySelector('#shopify-section-' + id + ' [data-hc-tierpop]');
    }
    function showInEditor(pop, panel) {
      var same = editor.blockId === panel.dataset.blockId;
      editor.blockId = panel.dataset.blockId;
      open(pop, panel, same);
    }
    document.addEventListener('shopify:section:load', function (e) {
      start();
      var pop = inSection(e.detail.sectionId);
      if (!pop || !editor.blockId) return;
      var panel = pop.querySelector('[data-block-id="' + editor.blockId + '"]');
      if (panel) open(pop, panel, true);
    });
    document.addEventListener('shopify:section:select', function (e) {
      var pop = inSection(e.detail.sectionId);
      if (!pop) return;
      var panel = (editor.blockId && pop.querySelector('[data-block-id="' + editor.blockId + '"]')) || pop.querySelector('[data-hc-tierpop-panel]');
      if (panel) showInEditor(pop, panel);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var pop = inSection(e.detail.sectionId);
      var panel = pop && pop.querySelector('[data-block-id="' + e.detail.blockId + '"]');
      if (panel) showInEditor(pop, panel);
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var pop = inSection(e.detail.sectionId);
      if (pop) pop.hidden = true;
      editor.blockId = null;
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
